import React, { useState, useEffect, useCallback } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../contexts/AuthContext'

export default function DebugTemplate() {
  const { user } = useAuth()
  const [templates, setTemplates] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const loadTemplates = useCallback(async () => {
    if (!user) return
    
    setLoading(true)
    setError(null)
    
    try {
      const { data, error } = await supabase
        .from('email_templates')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false })

      if (error) {
        console.error('Error loading templates:', error)
        setError(error.message)
        return
      }

      console.log('Loaded templates:', data)
      setTemplates(data || [])
    } catch (err) {
      console.error('Unexpected error:', err)
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [user])

  useEffect(() => {
    if (user) {
      loadTemplates()
    }
  }, [user, loadTemplates])

  if (!user) {
    return <div className="p-4 text-gray-500">ログインしてください</div>
  }

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-xl font-bold mb-4">テンプレートデバッグ情報</h2>
      
      <div className="mb-4">
        <button
          onClick={loadTemplates}
          disabled={loading}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
        >
          {loading ? '読み込み中...' : '再読み込み'}
        </button>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          エラー: {error}
        </div>
      )}

      <div className="space-y-4">
        <h3 className="text-lg font-semibold">テンプレート一覧 ({templates.length}件)</h3>
        
        {templates.length === 0 ? (
          <p className="text-gray-500">テンプレートがありません</p>
        ) : (
          templates.map((template, index) => (
            <div key={template.id} className="border border-gray-200 rounded p-4">
              <h4 className="font-semibold mb-2">テンプレート {index + 1}</h4>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <strong>ID:</strong> {template.id}
                </div>
                <div>
                  <strong>User ID:</strong> {template.user_id}
                </div>
                <div>
                  <strong>Name:</strong> {template.name || 'NULL'}
                </div>
                <div>
                  <strong>Title (if exists):</strong> {template.title || 'NULL'}
                </div>
                <div className="col-span-2">
                  <strong>Content:</strong>
                  <div className="mt-1 p-2 bg-gray-100 rounded text-xs max-h-32 overflow-auto">
                    {template.content || 'NULL'}
                  </div>
                </div>
                <div>
                  <strong>Created:</strong> {new Date(template.created_at).toLocaleString()}
                </div>
                <div>
                  <strong>Updated:</strong> {new Date(template.updated_at).toLocaleString()}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
} 